/**
 * Parses a dataValidationError array from the backend into a field-keyed error map.
 *
 * Two mapping strategies are supported:
 * 1. Path-based: errors with a nested path (e.g. "systems.0.system_name") use the
 *    last path segment as the field name. Array-level paths (e.g. "systems") are skipped.
 * 2. Structured msg: array-level validators that cannot use a nested path can instead
 *    throw { message: string, field: string } from their custom() function. The `field`
 *    property names the form input that should display the error.
 *
 * @param {Array<{ path: string, msg: string | { message: string, field: string } }>} errors
 * @returns {{ [fieldName: string]: string }}
 */
export function parseDataValidationErrors(errors) {
  const formErrors = {};
  errors.forEach(({ path, msg }) => {
    const segments = path.split('.');
    let fieldName;
    let message;

    if (segments.length > 1) {
      // Path-based: entity.0.field_name -> field_name
      fieldName = segments.at(-1);
      message = typeof msg === 'object' ? msg.message : msg;
    } else if (typeof msg === 'object' && msg.field) {
      // Structured msg: array-level validator with explicit field reference
      fieldName = msg.field;
      message = msg.message;
    }

    if (fieldName && !formErrors[fieldName]) {
      formErrors[fieldName] = message;
    }
  });
  return formErrors;
}
